import { useMutation } from "@tanstack/react-query";
import API from "../../api/api";


const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const ShoppingService = {
    callRepurchaseItems: async (activeTabBtn) => {
        const response = await callApi('repurchase-products?type=' + activeTabBtn);
        return response
    },
    callCartItems: async (type) => {
        const response = await callApi(`get-cart?type=${type}`);
        return response
    },
    callAddToCart: async (data, activeTab) => {
        return API.post(`add-to-cart?type=${activeTab}`, JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callDecrementCartItem: async (data, activeTab) => {
        return API.patch(`decrement-cart-item?type=${activeTab}`, JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callRemoveCartItem: async (data, type) => {
        return API.delete(`remove-cart-item?type=${type}`, { data: JSON.stringify(data) })
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callAddAddress: async (data) => {
        return API.post("add-address", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callAddress: async (userId, forUserId) => {
        const response = await callApi(`get-address?userId=${userId}&forUserId=${forUserId}`);
        return response
    },
    callPaymentMethods: async (action) => {
        const response = await callApi(`payment-methods?action=${action}`)
        return response
    },
    callRemoveAddress: async (data) => {
        return API.delete("delete-address", { data: JSON.stringify(data) })
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callProductDetails: async (id, type) => {
        const response = await callApi(`repurchase-product-detail?id=${id}&type=${type}`);
        return response
    },
    callDefaultAddressChange: async (id) => {
        return API.patch(`change-default-address?newDefaultId=${id.addressId}&userId=${id.forUserId}`)
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callPlaceRepurchaseOrder: async (data, type) => {
        return API.post(`place-repurchase-order?type=${type}`, JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callRepurchaseReport: async (page,limit, sortBy, direction, activeTab) => {
        const response = await callApi(`repurchase-report?page=${page}&perPage=${limit}&sortBy=${sortBy}&direction=${direction}&type=${activeTab}`)
        return response
    },
    callAwardsRewards: async (page,limit, sortBy, direction) => {
        const response = await callApi(`awards-rewards?page=${page}&perPage=${limit}&sortBy=${sortBy}&direction=${direction}`)
        return response
    },
    callPurchaseInvoice: async (orderId, activeTab) => {
        const response = await callApi(`repurchase-invoice?invoiceNo=${orderId}&type=${activeTab}`)
        return response
    },
    callCreateReport: async (reportType, fileType) => {
        const response = await API.post(`create-report?reportType=${reportType}&fileType=${fileType}`)
        return response
    },
    useCheckUsername: (activeTab='') => {
        return useMutation(async(data) =>  await callApi(`check-username?username=${data.username}&type=${activeTab}`))
    },
}